import { FC } from 'react';
import { ShowcaseSection } from '@routes/theme-showcase/components/ShowcaseSection';
import { ShowcaseToolbar } from '@routes/theme-showcase/components/ShowcaseToolbar';
import { AtomsShowcase } from '@routes/theme-showcase/sections/AtomsShowcase';
import { MoleculesShowcase } from '@routes/theme-showcase/sections/MoleculesShowcase';
import { ReactstrapShowcase } from '@routes/theme-showcase/sections/ReactstrapShowcase';
import Dashboard from '@g17eco/molecules/dashboard';

export const ThemeShowcase: FC = () => {
  return (
    <Dashboard>
      <div className='d-flex flex-column'>
        <ShowcaseToolbar />
        <h1 className='mb-5 display-4'>Theme Showcase</h1>
        <p className='lead mb-5 text-ThemeTextLight'>
          Visual verification of UI components across light/dark modes and company/materiality themes.
        </p>

        <ShowcaseSection title='Atoms'>
          <AtomsShowcase />
        </ShowcaseSection>

        <ShowcaseSection title='Molecules'>
          <MoleculesShowcase />
        </ShowcaseSection>

        <ShowcaseSection title='Reactstrap Components'>
          <ReactstrapShowcase />
        </ShowcaseSection>
      </div>
    </Dashboard>
  );
};
